<ng-container *ngIf=" !disabled && (draggableService?.isDragging$ | async) ">

  <ng-container *ngIf=" block ">

    <div *ngIf=" !isColumn "
         class="above"
         [style.right.px]=" groupStyles ? +groupStyles.padding.right + 4 : null "
         [style.left.px]=" groupStyles ? +groupStyles.padding.left + 4 : null "
         [style.height.px]=" groupStyles ? +groupStyles.padding.top + 10 : null "
         (drop)="drop($event) ">

      <div class="placeholder"
           [style.right.px]=" groupStyles ? -groupStyles.padding.right : null "
           [style.left.px]=" groupStyles ? -groupStyles.padding.left : null "></div>

    </div>

    <div *ngIf=" !isRow && !isColumnChild"
         class="after"
         [style.margin-left.px]=" groupStyles ? -groupStyles.padding.right - 4 : null "
         (drop)="drop($event) ">

      <div class="placeholder"></div>

    </div>

    <div *ngIf=" !isColumn "
         class="below"
         [style.right.px]=" groupStyles ? +groupStyles.padding.right + 4 : null "
         [style.left.px]=" groupStyles ? +groupStyles.padding.left + 4 : null "
         [style.height.px]=" groupStyles ? +groupStyles.padding.bottom + 10 : null "
         (drop)="drop($event) ">

      <div class="placeholder"
           [style.right.px]=" groupStyles ? -groupStyles.padding.right : null "
           [style.left.px]=" groupStyles ? -groupStyles.padding.left : null "></div>

    </div>

    <div *ngIf=" !isRow && !isColumnChild "
         class="before"
         [style.margin-right.px]=" groupStyles ? -groupStyles.padding.left - 4 : null "
         (drop)="drop($event) ">

      <div class="placeholder"></div>

    </div>

  </ng-container>

  <div *ngIf=" !block && !isColumn "
       class="inside"
       (drop)="drop($event) ">

    <div class="placeholder"></div>

  </div>

  <div *ngIf="isOverlay"
       (drop)="drop($event) "
       class="inside left-outside">
  </div>

  <div *ngIf="isOverlay"
       (drop)="drop($event) "
       class="inside top-outside">
  </div>

</ng-container>

<ng-content></ng-content>
